import {useRuntimeConfig} from "#imports";

export const useAPIBaseUrl = (): string | undefined => {
	if (import.meta.server) return undefined;

	const getRuntimeConfig = useRuntimeConfig as typeof import("nuxt/app").useRuntimeConfig;
	const config = getRuntimeConfig();
	const apiBase = config.public?.apiBase;
	return typeof apiBase === "string" ? apiBase : "";
};